import ReactDatePicker from "react-datepicker";
import { forwardRef, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDatePickerLocale } from "src/i18n/useDatePickerLocale";

interface Props {
  dateRange: [Date | null, Date | null];
  onDateRangeChange: (dateRange: [Date | null, Date | null]) => void;
  disabled?: boolean;
}

/**
 * react-datepicker 4.8.0 은 selectsRange 선택값을 `${start} - ${end}` 로 고정 조합하며 구분자 옵션이 없다.
 * 날짜 구분자 "-" 와 구분되도록 구간 기호만 "~" 로 바꿔 표시한다.
 */
const toRangeDisplayValue = (value?: string) => value?.replace(" - ", " ~ ");

function RangeDatepicker(props: Props) {
  const [startDate, endDate] = props.dateRange;
  const { t, i18n } = useTranslation("common");
  const locale = useDatePickerLocale();
  const isEnglish = i18n.language?.startsWith("en");

  const RangeDatePinkerInput = forwardRef<HTMLInputElement, any>(({ value, ...props }, ref) => {
    const inputRef = useRef<HTMLInputElement>(ref as any);

    const handleClickIcon = () => inputRef.current?.focus();

    return (
      <div className="range-datepicker-input">
        <input value={toRangeDisplayValue(value)} {...props} ref={inputRef} />
        <div className="icon" onClick={handleClickIcon} />
      </div>
    );
  });

  return (
    <ReactDatePicker
      selectsRange={true}
      onChange={props.onDateRangeChange}
      calendarClassName="base-datepicker range-datepicker"
      dateFormat={"yyyy-MM-dd"}
      locale={locale}
      formatWeekDay={isEnglish ? (dayName) => dayName.slice(0, 3) : undefined}
      startDate={startDate}
      endDate={endDate}
      customInput={<RangeDatePinkerInput />}
      placeholderText={t("selectPeriod")}
      showPopperArrow={false}
      popperPlacement="bottom"
      disabled={props.disabled}
    />
  );
}
export default RangeDatepicker;
